// What Message hands the shared component as `customisations`. footerComponent is the library's footer slot; Message builds it
// per render and adds it to these.
export const CUSTOMISATIONS_BASE = {
  sendButtonText: 'Save',
  onlyVariable: false,
  enableSingleSelection: true,
  hideSuccessMessage: true,
};
